import { MsgExecuteContractCompat } from '@injectivelabs/sdk-ts'
import { msgBroadcaster } from '@shared/WalletService'
import { VOTE_CONTRACT_ADDRESS } from '@/app/utils/constant'
import { backupPromiseCall, delayPromiseCall } from '@/app/client/utils/async'

export const voteProject = async (project: string) => {
  const voteStore = useVoteStore()
  const walletStore = useWalletStore()
  const sharedWalletStore = useSharedWalletStore()

  if (
    !sharedWalletStore.isUserConnected ||
    !sharedWalletStore.defaultSubaccountId
  ) {
    return
  }

  await walletStore.validateAndQueue()

  const message = MsgExecuteContractCompat.fromJSON({
    sender: sharedWalletStore.injectiveAddress,
    contractAddress: VOTE_CONTRACT_ADDRESS,
    exec: {
      action: 'add_user_vote',
      msg: { project_name: project }
    }
  })

  const tx = await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  backupPromiseCall(() =>
    Promise.all([voteStore.fetchProjects(), voteStore.fetchUserVote()])
  )

  return tx
}

export const addWhitelistedAddresses = async ({
  addresses
}: {
  addresses: string[]
}) => {
  const voteStore = useVoteStore()
  const walletStore = useWalletStore()
  const sharedWalletStore = useSharedWalletStore()

  if (
    !sharedWalletStore.isUserConnected ||
    !sharedWalletStore.defaultSubaccountId
  ) {
    return
  }

  await walletStore.validateAndQueue()

  const message = MsgExecuteContractCompat.fromJSON({
    contractAddress: VOTE_CONTRACT_ADDRESS,
    sender: sharedWalletStore.injectiveAddress,
    exec: {
      action: 'add_addresses_to_whitelist',
      msg: {
        addresses
      }
    }
  })

  const tx = await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  await delayPromiseCall(
    async () => await voteStore.fetchWhitelistedAddressesCount(),
    5 * 1000
  )

  return tx
}

export const removeWhitelistedAddresses = async ({
  addresses
}: {
  addresses: string[]
}) => {
  const voteStore = useVoteStore()
  const walletStore = useWalletStore()
  const sharedWalletStore = useSharedWalletStore()

  if (
    !sharedWalletStore.isUserConnected ||
    !sharedWalletStore.defaultSubaccountId
  ) {
    return
  }

  await walletStore.validateAndQueue()

  const message = MsgExecuteContractCompat.fromJSON({
    contractAddress: VOTE_CONTRACT_ADDRESS,
    sender: sharedWalletStore.injectiveAddress,
    exec: {
      action: 'remove_addresses_from_whitelist',
      msg: {
        addresses
      }
    }
  })

  const tx = await msgBroadcaster.broadcastV2({
    injectiveAddress: sharedWalletStore.injectiveAddress,
    msgs: message
  })

  await delayPromiseCall(
    async () => await voteStore.fetchWhitelistedAddressesCount(),
    5 * 1000
  )

  return tx
}
